import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { ReferralCard } from "./ReferralCard";
import { Badge, LEVEL_LABELS, StatCard, fmtDate, money } from "./ui";

export const OfficeHome = ({ data, goTo }) => {
  const { profile, earnings, levels, level_amounts: amounts } = data;
  const active = profile.membership_status === "activa";
  return (
    <div data-testid="office-home">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf-deep">Oficina virtual</p>
          <h2 className="mt-2 font-display text-3xl font-semibold tracking-tight sm:text-4xl" data-testid="office-name">Hola, {profile.name.split(" ")[0]}</h2>
          <p className="mt-2 flex flex-wrap items-center gap-3 text-sm text-ink/70">
            <span>ID <span className="font-mono text-base font-semibold text-ink" data-testid="office-dist-id">{profile.dist_id}</span></span>
            <Badge status={profile.membership_status} testId="office-membership-badge" />
            {profile.sponsor_id && <span>Patrocinador: <span className="font-mono">{profile.sponsor_id}</span></span>}
          </p>
        </div>
      </div>

      {!active && (
        <div className="mt-6 flex flex-col gap-4 rounded-2xl border border-sun/60 bg-sun/15 p-5 sm:flex-row sm:items-center sm:justify-between" data-testid="office-activate-banner">
          <div className="flex gap-3">
            <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-[#8a6a00]" />
            <div>
              <p className="font-semibold">Tu Membresía Dorada está pendiente de pago</p>
              <p className="mt-1 text-sm text-ink/75">Tus referidos ya cuentan en tu red, pero tus comisiones solo podrán pagarse cuando tu membresía esté activa.</p>
            </div>
          </div>
          <button onClick={() => goTo("membresia")} className="btn-ink shrink-0 !px-5 !py-3 !text-sm" data-testid="office-activate-btn">Activar membresía</button>
        </div>
      )}

      <div className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-4">
        <StatCard dark label="Ganancias generadas" value={money(earnings.total)} testId="stat-earnings-total" />
        <StatCard label="Ya cobradas" value={money(earnings.paid)} testId="stat-earnings-paid" />
        <StatCard label="Pendientes de pago" value={money(earnings.pending)} testId="stat-earnings-pending" />
        <StatCard label="Personas en tu red" value={data.network_total} hint={`${data.network_active} con membresía activa`} testId="stat-network-total" />
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-[1.2fr_1fr]">
        <ReferralCard distId={profile.dist_id} name={profile.name} />
        <div className="rounded-[1.5rem] border border-ink/10 bg-white p-6" data-testid="office-levels-card">
          <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf-deep">Tu red por niveles</p>
          <ul className="mt-4 divide-y divide-ink/10">
            {Object.entries(levels).map(([lvl, c]) => (
              <li key={lvl} className="flex items-center justify-between py-2.5 text-sm" data-testid={`level-row-${lvl}`}>
                <span className="font-semibold">{LEVEL_LABELS[lvl]}</span>
                <span className="text-ink/70">{c.total} personas · {c.activos} activas</span>
                <span className="font-mono text-xs text-leaf-deep">{money(amounts[lvl])} c/u</span>
              </li>
            ))}
          </ul>
          <button onClick={() => goTo("red")} className="mt-4 text-sm font-semibold text-leaf-deep underline-offset-4 hover:underline" data-testid="office-go-network">Ver genealogía completa →</button>
        </div>
      </div>

      {active && (
        <p className="mt-6 text-xs text-ink/55">Membresía activa desde {fmtDate(profile.membership_paid_at)}. Comparte tu enlace y revisa tus <button onClick={() => goTo("ganancias")} className="font-semibold text-leaf-deep underline-offset-2 hover:underline">ganancias</button>. ¿Dudas? <Link to="/#faq" className="underline underline-offset-2">Preguntas frecuentes</Link>.</p>
      )}
    </div>
  );
};
